export var ToolbarTooltipDelay;
(function (ToolbarTooltipDelay) {
    ToolbarTooltipDelay[ToolbarTooltipDelay["Open"] = 250] = "Open";
    ToolbarTooltipDelay[ToolbarTooltipDelay["Close"] = 150] = "Close";
})(ToolbarTooltipDelay || (ToolbarTooltipDelay = {}));
